export const baseURL = process.env.REACT_APP_API_URL;

export const prefix_api_path = '/api/v1';
